import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Popup from '../../DesignSystem/Popups/Popup';
import { ReactComponent as InformationIcon } from '../../../assets/icons/information.svg';
import WorkbookGuidance, { WorkbookResultWording } from './WorkbookGuidance';
import { workbookCopy } from './workbookCopy';
import '../../../css/DesignSystem/Buttons/IconButton.css';

const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const percent = new Intl.NumberFormat('en-GB', { style: 'percent', maximumFractionDigits: 2 });
const format = (key, value) => key === 'oldPlanTaxFreeCashRatio' ? percent.format(value) : money.format(value);

export default function WorkbookInfoButton({ calculator, getResult }) {
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState(null);
  const trigger = useRef(null);
  const popup = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const focusable = () => [...(popup.current?.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]') || [])].filter(element => !element.disabled && !element.hidden);
    focusable()[0]?.focus();
    const trap = event => {
      if (event.key !== 'Tab') return;
      const elements = focusable(); const first = elements[0]; const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      else if (!popup.current?.contains(document.activeElement)) { event.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', trap);
    return () => { document.removeEventListener('keydown', trap); document.body.style.overflow = previousOverflow; trigger.current?.focus(); };
  }, [open]);
  if (!workbookCopy[calculator.id]) return null;
  return <>
    <button ref={trigger} type="button" className="ds-icon-button" aria-label={calculator.label + ' information'} title="Calculator information" aria-haspopup="dialog" aria-expanded={open} onClick={() => { setResult(getResult?.() || null); setOpen(true); }}>
      <InformationIcon aria-hidden="true" />
    </button>
    {open && createPortal(<div ref={popup}>
      <Popup open title={calculator.label + ' - information'} titleAlign="left" titleClassName="FP_H3" className="ds-confirmation-popup--form" showCancel={false} confirmLabel="Close" onConfirm={close} onCancel={close}>
        <WorkbookGuidance calculatorId={calculator.id} />
        {result && <WorkbookResultWording calculatorId={calculator.id} result={result} format={format} />}
      </Popup>
    </div>, document.body)}
  </>;
}
